import { render, staticRenderFns } from "./customProgramsRegistrationList.vue?vue&type=template&id=6b525f79&scoped=true"
import script from "./customProgramsRegistrationList.vue?vue&type=script&lang=js"
export * from "./customProgramsRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./customProgramsRegistrationList.vue?vue&type=style&index=0&id=6b525f79&prod&lang=less&scoped=true"
import style1 from "./customProgramsRegistrationList.vue?vue&type=style&index=1&id=6b525f79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b525f79",
  null
  
)

export default component.exports